/*jshint browser: true, jquery: true, indent: 4*/

$(window).load(function() {

    // scroll na obsah

    if($('body[data-scrolling]').length) {
        setTimeout(function() {
            $('html, body').scrollTop($('.contentBody').offset().top);
        }, 0);
    }
});

$(function() {

    var $loginForm = $('.login');

    // Superfish menu
    // Otevreni menu

    (function() {
        var $toggle = $('.menuToggle'),
            $menu = $('.mainMenu'),
            $mainMenuUl = $('.mainMenu .sf-menu');

        $mainMenuUl.superfish({
            delay: 500,
            speed: 300,
            speedOut: 300,
            onHide: function() {
                $mainMenuUl.animate({
                    left: 0
                }, 300);
                $menu.css({
                    height: 'auto'
                });
            },
            onShow: function() {
                if($toggle.is(':visible')) {
                    $mainMenuUl.stop(true).animate({
                        left: -$menu.innerWidth()
                    }, 300);
                    $menu.animate({
                        height: $(this).height()
                    }, 300);
                }
            }
        });

        $mainMenuUl.find('a:not(ul ul a)').on('mouseenter', function() {
            var $this = $(this);
            if($this.hasClass('sf-with-ul')) {
                $loginForm.removeClass('open').find('.box').fadeOut(300);
            } else {
                $mainMenuUl.superfish('hide');
            }
        });

        $toggle.click(function() {
            $menu.fadeToggle(300);
            $loginForm.removeClass('open').find('.box').fadeOut(300);
        });
    })();

    function fn_nl_lib_anchor() {
        var $hash = window.location.hash;

        $.fn.anchor_anim = function (duration) {
            var $elm = $(this),
                $offset = 0;

            $('html, body').animate({
                scrollTop: $elm.offset().top - 64
            }, duration);
        };

        $('a[href^="#"]').on("click",function(e){
            e.preventDefault();

            var $elm = $(this).attr("href");

            if($($elm).length) {
                $($elm).anchor_anim(300);
            } else if ($('[name='+$elm.replace('#','')+']').length) {
                $('[name='+$elm.replace('#','')+']').anchor_anim(300);
            }
        });

        $("[id]").each(function(){
            var $elm = $(this);
            if($hash && $elm.attr("id") === $hash.replace('#','')) {
                setTimeout(function(){
                    $elm.anchor_anim(300);
                },500);
            }
        });
        $("[name]").each(function(){
            var $elm = $(this);
            if($hash && $elm.attr("name") === $hash.replace('#','')) {
                setTimeout(function(){
                    $elm.anchor_anim(300);
                },500);
            }
        });
    }
    fn_nl_lib_anchor();

    // Otevirani menu jazyku
    $('.lang').click(function(evt) {
        if($(evt.target).is('a')) {
            return;
        }
        $(this).toggleClass('open');
    });



    // Otevirani login formu

    $loginForm.find('.toggle, [data-action=close]').click(function() {
        $loginForm.toggleClass('open').find('.box').fadeToggle(300);
        $('.mainMenu .sf-menu').superfish('hide');
    });

    // Scroll tlacitka
    var $scrollBtn = $('a.scrollDown');
    if($scrollBtn.length) {
        $scrollBtn.click(function() {
            var $this = $(this);

            $('html, body').animate({
                scrollTop: $($this.attr('href')).offset().top
            }, 300);
        });
    }

    // zuzovani headeru

    (function() {
        var $class = $('.mainHeader, .mainLogo'),
            $win = $(window),
            scrollTop = $win.scrollTop(),
            prevScrollTop = 0,
            breakpoint = 320;

        $win.on('load scroll', function() {
            scrollTop = $win.scrollTop();

            if((scrollTop - breakpoint) * (prevScrollTop - breakpoint) <= 0) {
                $class.toggleClass('contracted', scrollTop > breakpoint);
            }

            prevScrollTop = scrollTop;
        });
    })();

    // HP slider

    (function() {
        var $HPSlider = $('.HPSlider .slides');

        if(!$HPSlider.length) {
            return;
        }

        var videos = $HPSlider.find('video').length > 0;

        $HPSlider.on('init afterChange', function(evt, slick) {
            videos && slick.$slides.eq(slick.currentSlide).find('video')[0].play();
        });

        if($HPSlider.length) {
            /*$HPSlider.flexslider({
                directionNav: false,
                slideshowSpeed: 10000,
                animationSpeed: 2500
            });*/
            $HPSlider.slick({
                fade: true,
                appendArrows: false,
                dots: true,
                speed: parseInt($HPSlider.data('transition-duration')) || 2500,
                autoplay: true,
                autoplaySpeed: 6000,
                pauseOnHover: false
            });
        }

        var slickObj = $HPSlider.slick('getSlick');

        $HPSlider.on('beforeChange', repositionVideoInSlider);
        $HPSlider.on('beforeChange', function(evt, slick, current, next) {
            videos && slick.$slides.eq(current).find('video')[0].pause();
        });

        $HPSlider.on('afterChange', function() {
            videos && slickObj.$slides.eq(slickObj.currentSlide).find('video')[0].play();
        });

        $HPSlider.find('video')/*.on('ended', function() {
            var video =  this;
            if(slickObj.$slides.eq(slickObj.currentSlide).has(video).length) {
                slickObj.slickNext();

                $HPSlider.one('afterChange', function() {
                    video.currentTime = 0;
                });
            }
        })*/.each(function() {
            this.playbackRate = this.defaultPlaybackRate = parseFloat($(this).data('rate')) || 1;
        });

        function repositionVideoInSlider(evt, slick, current, next) {
            var $video = slickObj.$slides.eq((typeof next == 'number') ? next : (current || slickObj.currentSlide)).find('video').css({
                    width: 'auto',
                    height: 'auto'
                }),
                vw = $video.width(),
                vh = $video.height(),
                sw = $HPSlider.width(),
                sh = $HPSlider.height(),
                vRatio = vw / vh,
                sRatio = sw / sh;

            if(vRatio > sRatio) {
                $video.css({
                    height: sh,
                    top: 0
                }).css({
                    left: ~~((sw - $video.width()) / 2)
                });
            } else {
                $video.css({
                    width: sw,
                    left: 0
                }).css({
                    top: ~~((sh - $video.height()) / 2)
                });
            }
        }

        $(window).on('resize', repositionVideoInSlider);
        setTimeout(repositionVideoInSlider, 0);
    })();



    // Refs slider v referencich

    var $refsRefsSlider = $('.refsRefs .flexslider .slides');
    if($refsRefsSlider.length) {
        $refsRefsSlider.slick({
            autoplay: true,
            autoplaySpeed: $refsRefsSlider.data('slideshow-speed') || 5000,
            slidesToShow: 3,
            responsive: [
                {
                  breakpoint: 960,
                  settings: {
                    slidesToShow: 2
                  }
                },
                {
                  breakpoint: 720,
                  settings: {
                    slidesToShow: 1
                  }
                }
            ]
        });
    }



    // reference dole na strance

    var $refSliders = $('.HPRefs .left .flexslider .slides');
    $refSliders.each(function() {
        var $slider = $(this);

        $slider.slick({
            autoplay: true,
            autoplaySpeed: $slider.data('slideshow-speed') || 5000,
            variableWidth: true
        });
    });



    // Mapa v kontaktu
    (function() {
        var mapEl = document.getElementById('contactMap'),
            $map = $(mapEl),
            map,
            mapOptions,
            centerStr,
            centerRegExp = /[\d\.]+/g,
            center,
            marker;

        if(mapEl) {
            centerStr = $map.data('coords');
            center = {
                lat: parseFloat(centerRegExp.exec(centerStr)[0]),
                lng: parseFloat(centerRegExp.exec(centerStr)[0])
            };

            mapOptions = {
                center: center,
                zoom: 15,
                scrollwheel: false,
                draggable: false
            };

            map = new google.maps.Map(mapEl, mapOptions);

            marker = new google.maps.Marker({
                position: center,
                map: map,
                title: "SC Servis, s.r.o."
            });

            google.maps.event.addDomListener(map, 'click', function() {
                map.setOptions({
                    scrollwheel: true,
                    draggable: true
                });
            });
        }
    })();



    // Slider v referencich
    (function() {
        var $slider = $('.refsSlider .flexslider .slides');

        if($slider.length === 0) { return; }

        $slider.slick({
            autoplay: true,
            autoplaySpeed: $slider.data('slideshow-speed') || 5000,
            slidesToShow: 3,
            responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 2
                  }
                },
                {
                  breakpoint: 800,
                  settings: {
                    slidesToShow: 1
                  }
                }
            ]
        });
    })();



    // responze search formu v hlavicce
    (function() {
        $('.mainHeader .search [type=submit]').click(function(evt) {
            var $input = $(this).prev('input');
            if($input.css('opacity') > .2) {
                return;
            }
            evt.preventDefault();
            $input.focus();
        });
    })();



    // pojizdne titulky
    (function() {
        var $heading = $('.contentHeading.extra');

        if(!$heading.length) {
            return;
        }

        var $win = $(window),
            $content = $('.contentBody'),
            wasFixed = false,
            $floated = $(document.createElement('div')).addClass('floatedContentHeading'),
            $button = $(document.createElement('button')).addClass('scrollToTop').appendTo($floated),
            bottomOffset = 0;

        $button.click(function() {
            $('html, body').animate({ scrollTop: 0}, 500);
        });

        $floated.append($heading.find('h1, .productLogo').clone());
        $floated.appendTo('.content');

        $win.on('load scroll', function() {
            bottomOffset = Math.max(bottomOffset, $floated.outerHeight() + $floated.position().top);

            var scrollTop = $win.scrollTop(),
                contentTop = $content.offset().top - 50,
                contentBottom = contentTop + $content.outerHeight() - bottomOffset,
                toFix = (scrollTop - contentTop) * (scrollTop - contentBottom) <= 0;

            if(toFix != wasFixed) {
                $floated.stop(true).fadeToggle(toFix);
                wasFixed = toFix;
            }
        });
    })();

    // New Logic link v pate
    $('.nlFoot > img').click(function(evt) {
        evt.preventDefault();
        $(this).siblings('.nlText').fadeToggle(300);
    });
});

// fix prekryti obsahu headerem na hash odkazech

function scrollToAnchor(evt) {
    if(!location.hash) {
        return;
    }

    setTimeout(function() {
        $('html, body').scrollTop($('a[name=' + location.hash.substring(1) + ']').offset().top - 50);
    });
}

$(window).on('load', scrollToAnchor);
$('a[href^="#"]').click(scrollToAnchor);
